var module = angular.module('octopusApp.infrastructure');

module.directive("externalDropdown", function ($compile) {
  return {
    link: function (scope, element, attrs) {
      var dropdownElement = null;
      scope.$on('$destroy', function () {
        if (dropdownElement) {
          dropdownElement.remove();
        }
      });

      element.click(function (e) {
        e.preventDefault();

        var data = scope.$eval(attrs.externalDropdown);
        var childScope = scope.$new();
        var template = $("#" + data.id);

        var text = [];
        text.push("<div class='dropdown dynamic-popups'>");
        text.push(" <a class='hidden' id='_externaldropdown_toggler' data-toggle='dropdown'></a>");
        text.push(template.html());
        text.push("</div>");

        var html = $compile(text.join(""))(childScope);

        _.each(data.scope, function (val, key) {
          childScope[key] = val;
        });
        childScope.$digest();

        var refPos = element.offset();
        var refHeight = element.outerHeight();
        var containerPos = $("#body").offset();

        dropdownElement = html;

        html.css({
          "position": "absolute",
          "z-index": "100000",
          "left": (refPos.left - 140) + "px",
          "top": (refPos.top + refHeight) + "px"
        });

        $(".dynamic-popups").remove();

        var parent = $("body");
        parent.append(html);

        var toggler = $("a#_externaldropdown_toggler", html).first();
        toggler.dropdown("toggle");

        return false;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/external_dropdown.js
// module id = 694
// module chunks = 1